import { toGqlId } from "@src/api/formatters/shopify";
import { useFetchProductQuery } from "@src/generated";
import NoImage from "@src/images/no_image.png";
import { useSelector } from "@src/store";
import { formatPrice } from "@src/store/slices/agProducts/util/formatPrice";
import { parsePrice } from "@src/store/slices/agProducts/util/parsePrice";
import { getExperienceCurrencyFormat } from "@src/store/slices/experiences/selectors/currency/getExperienceCurrencyFormat";

export const useProductImage = (productId?: string, image?: string) => {
  const shopifyId = productId ? toGqlId(productId, "Product") : "";
  const { data: response } = useFetchProductQuery({
    variables: { id: shopifyId },
    skip: Boolean(image || !productId),
  });
  return ((image || response?.product?.featuredImage?.url) ??
    NoImage) as string;
};

export const useProductVariantPrice = (
  productId?: string,
  variantId?: string,
  price?: string
) => {
  const currencyFormat = useSelector(getExperienceCurrencyFormat);

  const formattedProductId = productId ? toGqlId(productId, "Product") : "";
  const formattedVariantId = variantId
    ? toGqlId(variantId, "ProductVariant")
    : "";
  const { data: response } = useFetchProductQuery({
    variables: { id: formattedProductId },
    skip: Boolean(price || !formattedProductId),
  });
  if (price) {
    return price;
  }
  const variant = response?.product?.variants.edges.find(
    (e) => e.node.id === formattedVariantId
  );
  const value = variant?.node?.price;
  const parsed = parsePrice(value);
  return formatPrice(parsed, currencyFormat);
};
